import React from 'react';
import { ReactSVG } from 'react-svg';

interface SvgProps {
    src: string;
    title?: string;
    className?: string;
}

const Svg: React.FC<SvgProps> = ({ src, title, className }) => {
    return (
        <ReactSVG
            src={src}
            className={`d__svg ${className ? className : ''}`}
            title={title}
        />
    );
};

export default Svg;